// Export an array of topics for VA 1st Grade Math
const md1stMathQuizContent = [
  {
    "slug": "countby3s",
    "title": "Count By 3's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 3 when counting by 3’s?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "If you start at 6 and count by 3’s, what number comes next?",
        "answers": [
          { "text": "9", "correct": true },
          { "text": "8", "correct": false },
          { "text": "10", "correct": false }
        ]
      },
      {
        "question": "Which number is part of the 3’s pattern?",
        "answers": [
          { "text": "15", "correct": true },
          { "text": "14", "correct": false },
          { "text": "13", "correct": false }
        ]
      },
      {
        "question": "What number comes after 21 when counting by 3’s?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "25", "correct": false },
          { "text": "22", "correct": false }
        ]
      },
      {
        "question": "If you keep counting by 3’s, what number comes after 27?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "28", "correct": false },
          { "text": "31", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countby5s",
    "title": "Count By 5's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 5 when counting by 5's?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "6", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "What number comes after 25 when counting by 5's?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "35", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "What number do you say after 50 when counting by 5's?",
        "answers": [
          { "text": "55", "correct": true },
          { "text": "60", "correct": false },
          { "text": "65", "correct": false }
        ]
      },
      {
        "question": "Which list shows numbers counted by 5's?",
        "answers": [
          { "text": "5, 10, 15, 20, 25", "correct": true },
          { "text": "2, 4, 6, 8, 10", "correct": false },
          { "text": "1, 3, 5, 7, 9", "correct": false }
        ]
      },
      {
        "question": "What number comes before 100 when counting by 5's?",
        "answers": [
          { "text": "95", "correct": true },
          { "text": "90", "correct": false },
          { "text": "85", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "countby10s",
    "title": "Count By 10's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 10 when counting by 10's?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "What number comes after 40 when counting by 10's?",
        "answers": [
          { "text": "50", "correct": true },
          { "text": "45", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "Which list shows numbers counted by 10's?",
        "answers": [
          { "text": "10, 20, 30, 40, 50", "correct": true },
          { "text": "5, 10, 15, 20, 25", "correct": false },
          { "text": "2, 4, 6, 8, 10", "correct": false }
        ]
      },
      {
        "question": "What number comes before 100 when counting by 10's?",
        "answers": [
          { "text": "90", "correct": true },
          { "text": "80", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "How much does each number increase when you count by 10's?",
        "answers": [
          { "text": "10 more each time", "correct": true },
          { "text": "5 more each time", "correct": false },
          { "text": "2 more each time", "correct": false }
        ]
      }
    ]
  },

  {
    "slug": "greaterthanlessthan",
    "title": "Greater Than Less Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which is greater: 8 ___ 5?",
        "answers": [
          { "text": "8 > 5", "correct": true },
          { "text": "8 < 5", "correct": false },
          { "text": "8 = 5", "correct": false }
        ]
      },
      {
        "question": "Which is less: 3 ___ 7?",
        "answers": [
          { "text": "3 < 7", "correct": true },
          { "text": "3 > 7", "correct": false },
          { "text": "3 = 7", "correct": false }
        ]
      },
      {
        "question": "Which statement is true?",
        "answers": [
          { "text": "9 > 4", "correct": true },
          { "text": "9 < 4", "correct": false },
          { "text": "9 = 4", "correct": false }
        ]
      },
      {
        "question": "Which statement shows equal numbers?",
        "answers": [
          { "text": "6 = 6", "correct": true },
          { "text": "6 > 6", "correct": false },
          { "text": "6 < 6", "correct": false }
        ]
      },
      {
        "question": "Which side of the symbol faces the greater number?",
        "answers": [
          { "text": "The open side", "correct": true },
          { "text": "The closed side", "correct": false },
          { "text": "Both sides are equal", "correct": false }
        ]
      }
    ]
  },

  {
    "slug": "ordinalnumbers",
    "title": "Ordinal Numbers",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What position does 'first' represent?",
        "answers": [
          { "text": "1st", "correct": true },
          { "text": "2nd", "correct": false },
          { "text": "3rd", "correct": false }
        ]
      },
      {
        "question": "If you finish a race in 2nd place, what is your ordinal number?",
        "answers": [
          { "text": "Second", "correct": true },
          { "text": "Third", "correct": false },
          { "text": "First", "correct": false }
        ]
      },
      {
        "question": "Which ordinal number comes right after fifth?",
        "answers": [
          { "text": "Sixth", "correct": true },
          { "text": "Fourth", "correct": false },
          { "text": "Seventh", "correct": false }
        ]
      },
      {
        "question": "If the blue car finished 8th and the red car finished 9th, which car came first?",
        "answers": [
          { "text": "The blue car", "correct": true },
          { "text": "The red car", "correct": false },
          { "text": "They tied", "correct": false }
        ]
      },
      {
        "question": "What is the ordinal number for the position after tenth?",
        "answers": [
          { "text": "Eleventh", "correct": true },
          { "text": "Ninth", "correct": false },
          { "text": "Twelfth", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "dollarscents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "How many cents are in one dollar?",
        "answers": [
          { "text": "100", "correct": true },
          { "text": "50", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "How much is a nickel worth?",
        "answers": [
          { "text": "5 cents", "correct": true },
          { "text": "10 cents", "correct": false },
          { "text": "1 cent", "correct": false }
        ]
      },
      {
        "question": "Which president is on the penny?",
        "answers": [
          { "text": "Abraham Lincoln", "correct": true },
          { "text": "George Washington", "correct": false },
          { "text": "Thomas Jefferson", "correct": false }
        ]
      },
      {
        "question": "If you have 4 quarters, how much money do you have?",
        "answers": [
          { "text": "$1.00", "correct": true },
          { "text": "$0.50", "correct": false },
          { "text": "$0.75", "correct": false }
        ]
      },
      {
        "question": "How many dimes make one dollar?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
{
  "slug": "tellingtime",
  "title": "Telling Time",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "What does the little hand on a clock show?",
      "answers": [
        { "text": "The hour", "correct": true },
        { "text": "The minutes", "correct": false },
        { "text": "The seconds", "correct": false }
      ]
    },
    {
      "question": "What does the big hand on a clock show?",
      "answers": [
        { "text": "The minutes", "correct": true },
        { "text": "The hours", "correct": false },
        { "text": "The days", "correct": false }
      ]
    },
    {
      "question": "When the big hand points to the 3, how many minutes have passed?",
      "answers": [
        { "text": "15 minutes", "correct": true },
        { "text": "10 minutes", "correct": false },
        { "text": "20 minutes", "correct": false }
      ]
    },
    {
      "question": "When the little hand points to the 4, what time is it?",
      "answers": [
        { "text": "4 o’clock", "correct": true },
        { "text": "3 o’clock", "correct": false },
        { "text": "5 o’clock", "correct": false }
      ]
    },
    {
      "question": "How many minutes are between each number on a clock?",
      "answers": [
        { "text": "5 minutes", "correct": true },
        { "text": "10 minutes", "correct": false },
        { "text": "1 minute", "correct": false }
      ]
    }
  ]
},

{
  "slug": "nonstandard",
  "title": "Non-Standard",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "What does 'non-standard measurement' mean?",
      "answers": [
        { "text": "Measuring with everyday objects like hands or blocks", "correct": true },
        { "text": "Measuring with a ruler only", "correct": false },
        { "text": "Measuring time with a clock", "correct": false }
      ]
    },
    {
      "question": "Which is a non-standard unit of measurement?",
      "answers": [
        { "text": "Paper clips", "correct": true },
        { "text": "Inches", "correct": false },
        { "text": "Centimeters", "correct": false }
      ]
    },
    {
      "question": "If you measure your desk with pencils, what kind of measurement are you using?",
      "answers": [
        { "text": "Non-standard measurement", "correct": true },
        { "text": "Standard measurement", "correct": false },
        { "text": "Temperature measurement", "correct": false }
      ]
    },
    {
      "question": "Which object would NOT be used for non-standard measurement?",
      "answers": [
        { "text": "A ruler", "correct": true },
        { "text": "Blocks", "correct": false },
        { "text": "Crayons", "correct": false }
      ]
    },
    {
      "question": "Why do we use non-standard units first when learning to measure?",
      "answers": [
        { "text": "To understand size and comparison before using rulers", "correct": true },
        { "text": "Because rulers don’t work", "correct": false },
        { "text": "So we can measure faster", "correct": false }
      ]
    }
  ]
},
{
  "slug": "shapes",
  "title": "Shapes",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "How many sides does a triangle have?",
      "answers": [
        { "text": "3", "correct": true },
        { "text": "4", "correct": false },
        { "text": "5", "correct": false }
      ]
    },
    {
      "question": "How many sides does a rectangle have?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "3", "correct": false },
        { "text": "5", "correct": false }
      ]
    },
    {
      "question": "How many sides does a square have?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "6", "correct": false },
        { "text": "8", "correct": false }
      ]
    },
    {
      "question": "How many sides does a pentagon have?",
      "answers": [
        { "text": "5", "correct": true },
        { "text": "6", "correct": false },
        { "text": "4", "correct": false }
      ]
    },
    {
      "question": "How many sides does an octagon have?",
      "answers": [
        { "text": "8", "correct": true },
        { "text": "6", "correct": false },
        { "text": "5", "correct": false }
      ]
    }
  ]
},
{
  "slug": "pictograph",
  "title": "Pictograph",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "What does a pictograph use to show information?",
      "answers": [
        { "text": "Pictures or symbols", "correct": true },
        { "text": "Numbers only", "correct": false },
        { "text": "Words only", "correct": false }
      ]
    },
    {
      "question": "What tells us what each picture stands for in a pictograph?",
      "answers": [
        { "text": "The key", "correct": true },
        { "text": "The title", "correct": false },
        { "text": "The legend", "correct": false }
      ]
    },
    {
      "question": "If one picture equals 5 apples, how many apples do 3 pictures show?",
      "answers": [
        { "text": "15 apples", "correct": true },
        { "text": "10 apples", "correct": false },
        { "text": "5 apples", "correct": false }
      ]
    },
    {
      "question": "A pictograph is useful because it helps us:",
      "answers": [
        { "text": "See data clearly using pictures", "correct": true },
        { "text": "Write long paragraphs", "correct": false },
        { "text": "Measure length in inches", "correct": false }
      ]
    },
    {
      "question": "Which of the following would most likely be shown with a pictograph?",
      "answers": [
        { "text": "Number of pets in each class", "correct": true },
        { "text": "Steps in a recipe", "correct": false },
        { "text": "Temperature changes", "correct": false }
      ]
    }
  ]
}, 

]

export default md1stMathQuizContent;
